import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {HowToUnregisterComponent} from './how-to-unregister.component';

const routes: Routes = [
  {path: 'how-to-unregister', component: HowToUnregisterComponent},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})
export class HowToUnregisterRoutingModule { }
